export const isNumeric = (value: any): boolean => {
  return typeof value === "number" || parseInt(value).toString() === value;
};
